<div>
  <section class="content-header">
    <h1>Staff
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/user/home">
          <i class="fa fa-dashboard"></i> Home</a>
        </li>
        <li class="active">Staff</li>
      </ol>
    </section>
    <div class="box-header box box-primary mt-3">
      <div class="pull-left">
        <form class="form-inline">
          <div class="form-group">
            <label class="control-label">No. of entries</label>
          </div>
          <div class="form-group">
            <select
              style="display: inline;"
              #selectElem
              class="form-control"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="page.size"
              (change)="staffs$.next({ offset: 0 })"
              >
              @for (size of coreService.sizeOptions; track size) {
                <option
                  [value]="size"
                  >{{ size }}</option
                  >
                }
              </select>
            </div>
          </form>
        </div>

        <div class="pull-right">
          <button
            class="btn btn-sm btn-info btn-flat pull-left margin"
            style="margin-top: 0px;"
            (click)="resetFilters()"
            >
            Clear filters
          </button>
          <!-- <button
          *ngIf="group == groupTypes.ADMIN"
          style="margin-top: 0px;"
          class="btn btn-sm btn-info btn-flat pull-left margin"
          (click)="openModal('assign')"
          >
          Assign Staff
        </button> -->
        <button

          style="margin-top: 0px;"
          class="btn btn-sm btn-info btn-flat pull-right margin"
          (click)="openModal('create')"
          >
          Create Staff
        </button>
      </div>
    </div>
    <div class="box-body">
      <form [formGroup]="form">
        <ngx-datatable
          [externalSorting]="true"
          [cssClasses]="iconsCss"
          [loadingIndicator]="isLoading"
          class="material striped"
          [rows]="rows"
          [columnMode]="'force'"
          [headerHeight]="'auto'"
          [rowHeight]="'50'"
          [footerHeight]="50"
          [externalPaging]="true"
          [count]="page.totalElements"
          [offset]="page.pageNumber"
          (page)="staffs$.next($event)"
          (sort)="onSort($event)"
          [limit]="page.size"
          >
          <ngx-datatable-column
            [sortable]="false"
            prop="index"
            name="{{ 'Sr No' | uppercase }}"
            [flexGrow]="0"
            >
            <ng-template let-column="column" ngx-datatable-header-template>
              <p>{{ column.name }}</p>
            </ng-template>

            <ng-template
              let-row="row"
              let-rowIndex="rowIndex"
              let-value="value"
              ngx-datatable-cell-template
              >
              <strong>{{ page.size * page.pageNumber + rowIndex + 1 }}</strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            [sortable]="false"
            name="{{ 'Email' | uppercase }}"
            [flexGrow]="1"
            >
            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
              >
              <p>{{ row.email }}</p>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            [sortable]="true"
            name="{{ 'User Name' | uppercase }}"
            [flexGrow]="1"
            >
            <ng-template
              let-column="column"
              let-sort="sortFn"
              ngx-datatable-header-template
              >
              <p style="cursor: pointer;">
                {{ column.name }}
                <i aria-hidden="true"></i>
              </p>
              <!-- <input
              type="text"
              class="form-control input-sm"
              placeholder="Filter by {{ column.name | titlecase }}"
              formControlName="user_type"
              /> -->
            </ng-template>

            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
              >
              <p>
                {{ row.first_name }} {{ row.last_name }}
              </p>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            [sortable]="true"
            name="{{ 'User Type' | uppercase }}"
            [flexGrow]="1"
            >
            <ng-template
              let-column="column"
              let-sort="sortFn"
              ngx-datatable-header-template
              >
              <p style="cursor: pointer;">
                {{ column.user_type }}
              </p>
            </ng-template>

            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
              >
              <p>{{ row.user_type=="valet_attendant"? "Valet Attendant" : "Valet Supervisor" }}</p>
            </ng-template>
          </ngx-datatable-column>

          <!-- <ngx-datatable-column
          *ngIf="createGeneralStaff"
          name="{{ 'Parking Place' | uppercase }}"
          [flexGrow]="1"
          >
          <ng-template
            let-column="column"
            let-sort="sortFn"
            ngx-datatable-header-template
            >
            <p style="cursor: pointer;">
              {{ column.name }}
            </p>
          </ng-template>

          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
            >
            <p>
              {{ row.user_source }}
            </p>
          </ng-template>
        </ngx-datatable-column> -->


        <ngx-datatable-column

          [sortable]="false"
          name="{{ 'Actions' | uppercase }}"
          [flexGrow]="1"
          >
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
            >
            <a
              href="javascript:void(0);"

              (click)="deleteParkingStaff(row.id)"
              >
              <i
                aria-hidden="true"
                class="fa fa-trash-o  fa-fw"
                style="color:red; cursor: pointer;"
              ></i>
            </a>
            <a

              (click)="openModal('edit', row)"
              href="javascript:void(0);"
              >
              <i
                class="fa fa-pencil-square-o fa-fw"
                aria-hidden="true"
                data-toggle="tooltip"
                title="Edit Staff"
                >
              </i>
            </a>
            <a

              (click)="openModal('password', row)"
              href="javascript:void(0);"
              >
              <i
                class="fa fa-key"
                aria-hidden="true"
                data-toggle="tooltip"
                title="change password"
                >
              </i>
            </a>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </form>
  </div>
</div>
